let lockCount = 0;
let savedScrollY = 0;

export function lockBodyScroll() {
  if (typeof document === "undefined") return;

  lockCount += 1;
  if (lockCount > 1) return;

  savedScrollY = window.scrollY;

  document.documentElement.classList.add("is-scroll-locked");
  document.body.classList.add("is-scroll-locked");
  document.body.style.top = `-${savedScrollY}px`;
}

export function unlockBodyScroll({ restoreScroll = true } = {}) {
  if (typeof document === "undefined") return;

  lockCount = Math.max(0, lockCount - 1);
  if (lockCount > 0) return;

  document.documentElement.classList.remove("is-scroll-locked");
  document.body.classList.remove("is-scroll-locked");
  document.body.style.top = "";

  if (restoreScroll) {
    window.scrollTo(0, savedScrollY);
  }
}
